import {ChangeDetectorRef, Component, EventEmitter, Output} from '@angular/core';
import {Router} from "@angular/router";
import {animate, style, transition, trigger} from "@angular/animations";
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { QRCodeModule } from 'angularx-qrcode';

@Component({
  selector: 'app-qr-code-dialog',
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, QRCodeModule],
  templateUrl: './qr-code-dialog.component.html',
  styleUrls: ['./qr-code-dialog.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(10px)', opacity: 0 }),
        animate('0.17s ease-out',
          style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('0.17s ease-out',
          style({ transform: 'translateY(10px)', opacity: 0 }))
      ]),
    ]),
  ]
})
export class qrCodeDialogComponent {
  public link: string;

  @Output()
  closeDialog = new EventEmitter<void>();

  constructor(
    private readonly router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  private generateRedirectLink(): string {
    const relativePath = this.router.createUrlTree(['/app-store-redirect']).toString();
    return window.location.origin + relativePath;
  }

  ngOnInit() {
    this.link = this.generateRedirectLink();
    this.cdr.markForCheck();
  }

  public close() {
    this.closeDialog.emit();
  }
}
